export const handleChangeDataShopDetailsPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_SHOP_DETAILS', name, value
});